module.exports = __webpack_public_path__ + "static/media/go1.a1efa45a.jpg";